import { router } from 'expo-router'
import { Platform, View } from 'react-native'
import { StyleSheet, useUnistyles } from 'react-native-unistyles'

import UniIconButton from '@/components/unistyles/UniIconButton'
import buildOrgPath from '@/utils/orgRoute'

const UserListHeaderContent = () => {
  const { theme } = useUnistyles()

  return (
    <View style={styles.root}>
      {Platform.OS !== 'web' && (
        <UniIconButton
          icon="magnify"
          onPress={() => {
            router.push(buildOrgPath('/search'))
          }}
          testID="search-icon-button"
        />
      )}
      <UniIconButton
        icon="account-plus"
        iconColor={theme.colors.primary}
        onPress={() => {
          router.push(buildOrgPath('/users/invite'))
        }}
      />
    </View>
  )
}

const styles = StyleSheet.create(() => ({
  root: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
    gap: 2,
  },
}))

export default UserListHeaderContent
